"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const useNav_1 = __importDefault(require("@opsbase/web-nav/useNav"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const FeatureFlagged_1 = __importDefault(require("@opsbase/web-ui/FeatureFlagged"));
const react_1 = __importStar(require("react"));
const makeMyClasses = (collapse, depth) => {
    const size = !!depth ? 14 : 16;
    return {
        root: {
            minHeight: 32,
            borderRadius: 8,
            padding: !!depth ? '6px 16px' : undefined,
            '& .SVGIconRoot': {
                marginRight: `8px !important`,
            },
            '& .MuiButton-label': {
                fontSize: size,
                lineHeight: `${size}px`,
                padding: !!collapse && !!depth ? 0 : 4,
            },
        },
    };
};
function AppSideNavButton(props) {
    const { appNav, depth = 0, collapse = false } = props;
    const { goTo, openTo, isSelected } = (0, useNav_1.default)();
    const myCss = (0, web_css_1.default)(makeMyClasses, [collapse, depth]);
    const { label, link, flag, icon } = appNav;
    const selected = isSelected(appNav);
    const color = selected ? lib_palette_1.default.HelixSecondaryBoldHighlight : !depth ? lib_palette_1.default.White : lib_palette_1.default.GreyBlue;
    const handleClick = (0, react_1.useCallback)(e => {
        const meta = e.metaKey;
        e.stopPropagation();
        if (meta)
            openTo(link.replace(':viewId', 'default'));
        else
            goTo(link.replace(':viewId', 'default'));
    }, [link, goTo, openTo]);
    const iconBit = (0, react_1.useMemo)(() => {
        if (!icon || !!depth)
            return undefined;
        return (0, react_1.createElement)(icon, { size: 32 });
    }, [icon, depth]);
    const button = (0, react_1.useMemo)(() => {
        const txt = collapse && iconBit ? undefined : collapse && !iconBit ? label().substr(0, 6) : label();
        return (react_1.default.createElement(Button_1.default, { background: selected ? false : 'transparent', classes: { root: myCss.root }, onClick: handleClick, color: color, fullWidth: true, small: true, justify: "left", icon: iconBit, tooltip: collapse && !depth ? label() : undefined, label: txt }));
    }, [collapse, iconBit, label, selected, myCss, handleClick, color, depth]);
    return react_1.default.createElement(FeatureFlagged_1.default, { flag: flag }, button);
}
exports.default = AppSideNavButton;
